<div>
  <span class="d-flex align-items-center header-action-menu-user-icon-wrapper">
    <avatar
      [width]="24"
      [imageUrl]="imageUrl"
      [title]="userPerson?.previewName"
      #menuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="userMenu"
    />
    <header-action-menu-company [hidden]="!isExpanded" [ngClass]="{ expanded: isExpanded }" />
    <svg-icon
      class="pointer ml-auto"
      #menuTrigger="matMenuTrigger"
      mat-icon-button
      [hidden]="!isExpanded"
      [matMenuTriggerFor]="userMenu"
      [ngClass]="{ expanded: isExpanded }"
      src="/assets/img/three-dots-icon.svg"
    />
  </span>
  <mat-menu #userMenu="matMenu" xPosition="after" class="menu-v2">
    <button mat-menu-item (click)="n.go('user-settings')">
      <span>{{ 'settings' | translate }}</span>
    </button>
    <button mat-menu-item (click)="n.go('faq')">
      <span>{{ 'Header.faq' | translate }}</span>
    </button>
    <button mat-menu-item (click)="logout()" class="hover_red red-500">
      <span>{{ 'logout' | translate }}</span>
    </button>
  </mat-menu>
</div>
